import { subscribe, getAll, deleteByEmail } from './newsletterMethods';

export const supabaseNewsletterInit = (supabase) => { 
  return {
    subscribe: subscribe.bind(this, supabase),
    getAll: getAll.bind(this, supabase),
    deleteByEmail: deleteByEmail.bind(this, supabase),
  }
}

